import { ICON } from 'constants/common'
import React from 'react'

const IconStorage = ({ status = ICON.STATUS.DEFAULT }) => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_7587_16772)">
                <path d="M12.091 8.8055C16.6097 8.8055 20.2728 7.58446 20.2728 6.07822C20.2728 4.57199 16.6097 3.35095 12.091 3.35095C7.5723 3.35095 3.90918 4.57199 3.90918 6.07822C3.90918 7.58446 7.5723 8.8055 12.091 8.8055Z" stroke="#73777A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M20.2728 12.4419C20.2728 13.951 16.6365 15.1692 12.091 15.1692C7.54554 15.1692 3.90918 13.951 3.90918 12.4419" stroke="#73777A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M3.90918 6.07825V18.8055C3.90918 20.3146 7.54554 21.5328 12.091 21.5328C16.6365 21.5328 20.2728 20.3146 20.2728 18.8055V6.07825" stroke="#73777A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </g>
            <defs>
                <clipPath id="clip0_7587_16772">
                    <rect width="18.1818" height="20" fill="white" transform="translate(3 2.44189)" />
                </clipPath>
            </defs>
        </svg>
    )
}

export default IconStorage